
import { defineComponent } from 'vue';

import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';

import 'swiper/swiper.min.css';
import 'swiper/modules/pagination/pagination.min.css';

import SwiperCore, {
  Autoplay, Pagination, Navigation,
} from 'swiper';

SwiperCore.use([Autoplay, Pagination, Navigation]);
export default defineComponent({
  name: 'TheAboutSectionCompanies',
  components: { Swiper, SwiperSlide },
  data() {
    return {
      amountOfSlides: 3,
      spaceBetweenSlides: 100,
    };
  },
  mounted() {
    this.recalc();
    window.addEventListener('resize', () => {
      this.recalc();
    });
  },
  methods: {
    recalc() {
      this.amountOfSlides = window.innerWidth < 600 ? 3 : window.innerWidth / 260;
      this.spaceBetweenSlides = window.innerWidth < 600 ? 0 : 100;
    },
  },
});
